import { createContext, useContext, useEffect, useLayoutEffect, useState } from 'react';

const ThemeContext = createContext();

const localStorageThemeKey = 'verzel:theme';

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState('dark');

  const updateData = (theme) => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem(localStorageThemeKey, theme);
    setTheme(theme);
  }

  const toggleTheme = (overrideTheme = null) => {
    const newTheme = overrideTheme ?? theme === 'light' ? 'dark' : 'light';
    updateData(newTheme);
  };

  useEffect(() => {
    const savedTheme = localStorage.getItem(localStorageThemeKey);
    if (savedTheme) {
      updateData(savedTheme);
      return;
    } 
    
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const initialTheme = prefersDark ? 'dark' : 'light';
    updateData(initialTheme);
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  
  return context;
}; 